<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Medidas Socioeducativas</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load mode="table"
              v-if="loadingMedidas"/>
        <div class="col-md-12"
             v-else>

          <b-table
              :fields="[
                {
                  key: 'protocolo',
                  label: $t('Detalhes'),
                },
                {
                  key: 'created_at',
                  label: $t('Data'),
                },
          ]"
              :items="MedidasList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              Usuário: <b>{{ data.item.usuario_nome }}</b><br/>
              Unidade: <b>{{ data.item.unidade.nome }}</b><br/>
              Técnico: <b>{{ data.item.responsavel.name }}</b><br/>
              Protocolo: <b>{{ data.item.protocolo }}</b>
            </template>
            <template v-slot:cell(created_at)="data">
              Data inicial<b>{{ data.item.processo_data_inicial | formatDate }}</b><br/>
              Data final: <b>{{ data.item.processo_data_final | formatDate }}</b><br/>
            </template>

            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Medidas",
  props: ['familia'],
  data() {
    return {
      MedidasList: [],
      loadingMedidas: true,
    }
  },
  mounted() {
    this.getMedidas();
  },
  methods: {
    getMedidas() {

      this.loadingMedidas = true;
      axios
          .get(`api/dashboard/print/usuarios/medidas/${this.familia}`)
          .then((response) => {
            this.MedidasList = response.data.data;
            this.loadingMedidas = false;
          })
          .catch(() => {
            this.loadingMedidas = false;
          });
    },

  },
}
</script>

<style scoped>

</style>